import { memo, useCallback } from 'react';

import { WorkspaceAgentPanelConsentDock } from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/WorkspaceAgentPanelConsentDock';
import { WorkspaceAgentPanelConsentSummary } from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/WorkspaceAgentPanelConsentSummary';
import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { type UnknownElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';
import {
  FALLBACK_TOOL_CONSENT_INSTRUCTION,
  TOOL_CONSENT_DENY_LABEL,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getToolConsentDockCopy';

export type PrivateWorkspaceAgentPanelUnknownConsentDockProps = {
  elicitation: UnknownElicitation;
  onCancel: () => void;
};

export const PrivateWorkspaceAgentPanelUnknownConsentDock = memo(
  ({ elicitation, onCancel }: PrivateWorkspaceAgentPanelUnknownConsentDockProps) => {
    const session = usePrivateWorkspaceAgentPanelSession();

    // `agent_elicitation_responded` is limited to tool_consent docks today; revisit if unknown types ship in volume.
    const handleApprove = useCallback(() => {
      void session.respondToElicitation({ elicitationId: elicitation.id, response: 'approved' });
    }, [elicitation.id, session]);

    return (
      <WorkspaceAgentPanelConsentDock
        cancelLabel={TOOL_CONSENT_DENY_LABEL}
        data-testid="WORKSPACE_AGENT_CONSENT_UNKNOWN"
        onApprove={handleApprove}
        onCancel={onCancel}
        title="Approval required"
      >
        <WorkspaceAgentPanelConsentSummary summary={FALLBACK_TOOL_CONSENT_INSTRUCTION} />
      </WorkspaceAgentPanelConsentDock>
    );
  },
);

PrivateWorkspaceAgentPanelUnknownConsentDock.displayName = 'PrivateWorkspaceAgentPanelUnknownConsentDock';
